import { Sector, SectorProps } from 'recharts';

export const PieActiveShape = (props: SectorProps) => {
  const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill } = props;
  const SHADOW_WIDTH = 4;

  return (
    <g>
      <Sector cx={cx} cy={cy} innerRadius={innerRadius} outerRadius={outerRadius} startAngle={startAngle} endAngle={endAngle} fill={fill} aria-hidden={true} />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={(innerRadius || 0) - SHADOW_WIDTH}
        outerRadius={(outerRadius || 0) + SHADOW_WIDTH}
        fill={fill}
        fillOpacity={0.5}
        aria-hidden={true}
      />
    </g>
  );
};
